import { api } from '@/Data/api';
import ss from '../Session';

export type KoreanStudyType =
    | 'idol_stan' | 'k_content_lover' | 'social_butterfly' | 'travel_preparer'
    | 'aesthetic_learner' | 'skill_hunter' | 'academic_learner' | 'casual_learner';

export type KoreanStudyTypeResult = {
    result: (0 | 1 | 2 | 3)[];
    scores?: number[];
    type: KoreanStudyType;
};

type ApiResponse<T> = {
    code: number;
    data?: T;
    message?: string;
};

/**
 * Fetch Korean Study Type result for a specific user
 */
export const fetchKoreanStudyTypeAPI = async (addressid: string): Promise<KoreanStudyTypeResult | null> => {
    try {
        const res = await api.get<ApiResponse<KoreanStudyTypeResult>>(
            '/personatest/koreanstudytype',
            {
                params: { addressid },
                headers: { Authorization: `Bearer ${ss.getCurrentSession().jwt}` }
            }
        );

        if (res.data?.code === 200 && res.data.data?.type) {
            return res.data.data;
        }
        return null;
    } catch (e) {
        console.error('Failed to fetch Korean Study Type result:', e);
        return null;
    }
};

/**
 * Submit Korean Study Type answers and get result
 */
export const submitKoreanStudyTypeAPI = async (answers: (0 | 1 | 2 | 3)[]): Promise<KoreanStudyTypeResult | null> => {
    try {
        const res = await api.put<ApiResponse<KoreanStudyTypeResult>>(
            '/personatest/koreanstudytype',
            { result: answers },
            { headers: { Authorization: `Bearer ${ss.getCurrentSession().jwt}` } }
        );

        if (res.data?.code === 200 && res.data.data?.type) {
            return res.data.data;
        }
        return null;
    } catch (e) {
        console.error('Failed to submit Korean Study Type result:', e);
        return null;
    }
};
